import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
export var ListRememberButton = function (_a) {
    var onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    return (React.createElement(Button, { onClick: function (e) { return onClick(e); }, disabled: disabled, className: "listHeader__rememberButton" }, t('list.remember')));
};
export default ListRememberButton;
//# sourceMappingURL=ListRememberButton.js.map